import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { studyLabManagementServices } from "../../../../APIServices/studyLabManagementServices";

const UpdateLabManagement = ({
  rowData,
  getStudyLabManagementRowData,
  Show,
  Hide,
  Title,
  setRowId,
  modifiedMode
}) => {
  const [lowerRange, setLowerRange] = useState("");
  const [upperRange, setUpperRange] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  let { studyId } = useParams();

  const updateStudyLabManagementRowData = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update lab management!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.testId = rowData?.testId;
        userData.studyId = studyId;
        userData.mode = StudyMode;
        userData.lowerRange = lowerRange;
        userData.upperRange = upperRange;
        let data =
          await studyLabManagementServices.updateStudyLabManagementRowData(
            userData
          );
        if (data?.statusCode === 200) {
          getStudyLabManagementRowData();
          setRowId("");
          Hide();
        }
      }
      setButtonLoader(false);
    });
  };

  useEffect(() => {
    setLowerRange(rowData?.row?.[`LOWERRANGE_${modifiedMode}`]);
    setUpperRange(rowData?.row?.[`UPPERRANGE_${modifiedMode}`]);
  }, [rowData]);

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Lower Range{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setLowerRange(e.target.value)}
              value={lowerRange}
              className="br3"
              placeholder="Lower Range"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Upper Range{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setUpperRange(e.target.value)}
              value={upperRange}
              className="br3"
              placeholder="Upper Range"
              type="text"
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={!lowerRange || !upperRange || buttonLoader}
            onClick={updateStudyLabManagementRowData}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm"/> Updating...
              </div>
            ) : (
              "Update Range"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateLabManagement;
